import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";

import config from '../../config';
import axios from "axios";
import Swal from "sweetalert2";

const server_backend = config.API_URL;

const PaswordReset = () => {

    const [email, setEmail] = useState("");
    const navigate = useNavigate();

    const ResetPassword = async (e) => {
        e.preventDefault();

        try {
            const response = await axios.post(`${server_backend}/public/password_recover`, {
                username: email
            });

            if (response.data.RES_CODE === "00") {
                navigate('/password-recover-success');
                window.location.reload()
            } else {
                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: 'User does not exist.',
                    showConfirmButton: false,
                    timer: 1000
                });
            }

        } catch (error) {
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'unexpected error, if it persists contact your administrator.',
                showConfirmButton: false,
                timer: 1000
            });

        }

    };


    return (
        <div className="auth-page-wrapper auth-bg-cover py-5 d-flex justify-content-center align-items-center min-vh-100" style={{
            backgroundImage: 'url(assets/images/dbc-london1.jpg)',
            backgroundSize: 'cover',
            backgroundPosition: 'center'
        }}>
            <div className="bg-overlay"></div>
            <div className="auth-page-content overflow-hidden pt-lg-5">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="card overflow-hidden">
                                <div className="row justify-content-center g-0">
                                    <div className="col-lg-6">
                                        <div className="p-lg-5 p-4 h-100" style={{
                                            backgroundImage: 'url(assets/images/dbc-london1.jpg)',
                                            backgroundSize: 'cover',
                                            backgroundPosition: 'center'
                                        }}>
                                            <div className="bg-overlay"></div>
                                            <div className="position-relative h-100 d-flex flex-column">
                                                <div className="mb-4">
                                                    <Link to="" className="d-block">
                                                        <img src="assets/images/dbclondon-sm.jpg" alt="" height="80" style={{ borderRadius: "20px" }} />
                                                    </Link>
                                                </div>
                                                <div className="mt-auto">
                                                    <div className="mb-3">
                                                        <i className="ri-double-quotes-l display-4 text-success"></i>
                                                    </div>

                                                    <div id="qoutescarouselIndicators" className="carousel slide" data-bs-ride="carousel">
                                                        <div className="carousel-indicators">
                                                            <button type="button" data-bs-target="#qoutescarouselIndicators" data-bs-slide-to="0" className="active" aria-current="true" aria-label="Slide 1"></button>
                                                            <button type="button" data-bs-target="#qoutescarouselIndicators" data-bs-slide-to="1" aria-label="Slide 2"></button>
                                                            <button type="button" data-bs-target="#qoutescarouselIndicators" data-bs-slide-to="2" aria-label="Slide 3"></button>
                                                        </div>
                                                        <div className="carousel-inner text-center text-white pb-5">
                                                            <div className="carousel-item active">
                                                                <p className="fs-15 fst-italic">"Innovating in precious material smelting, ensuring quality and precision in every piece."</p>
                                                            </div>
                                                            <div className="carousel-item">
                                                                <p className="fs-15 fst-italic">"Transforming raw materials into masterpieces with advanced technology and expertise."</p>
                                                            </div>
                                                            <div className="carousel-item">
                                                                <p className="fs-15 fst-italic">"Committed to excellence at every step of the smelting and refining process."</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-lg-6">
                                        <form onSubmit={ResetPassword}>
                                            <div className="p-lg-5 p-4">
                                                <h5 className="text-primary">Forgot Password?</h5>
                                                <p className="text-muted">Reset password with DBC</p>

                                                <div className="mt-2 text-center">
                                                    <lord-icon src="https://cdn.lordicon.com/rhvddzym.json" trigger="loop" colors="primary:#0ab39c" className="avatar-xl">
                                                    </lord-icon>
                                                </div>

                                                <div className="alert alert-borderless alert-warning text-center mb-2 mx-2" role="alert">
                                                    Enter your username and instructions will be sent to you!
                                                </div>
                                                <div className="p-2">
                                                    <div className="mb-4">
                                                        <label className="form-label">Username</label>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            id="username"
                                                            value={email}
                                                            onChange={(e) => setEmail(e.target.value)}
                                                            required
                                                        />
                                                    </div>
                                                    <div className="text-center mt-4">
                                                        <button className="btn btn-success w-100" type="submit">Send Reset Link</button>
                                                    </div>
                                                </div>

                                                <div className="mt-5 text-center">
                                                    <p className="mb-0">Wait, I remember my password... <Link to="/login" className="fw-semibold text-primary text-decoration-underline"> Click here </Link> </p>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default PaswordReset;